import {environment} from '../../config/environment';
import ServiceRequest from '../ServiceRequest';
import {
  LoginResponseMapper,
  SignupParams,
  SignupResponseMapper,
  VerifyAccountParams,
  VerifyAccountResponseMapper,
  CreatePasswordParams,
  CreatePasswordResponseMapper,
  ForgetPasswordParams,
  ForgetPasswordResponseMapper,
  ResetPasswordParams,
  ResetPasswordResponseMapper,
  LoginWithAzureParams,
  FeedbackResponse
} from '../service-mappers/PublicServiceMapper';
export const adfsLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.adfsLogin;
export const adfsCallbackUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.adfsCallBack;
export const loginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.login;
export const signUpUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.signUp;
export const verifyUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.verifyUser;
export const createPasswordUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.createPassword;
export const forgetPasswordUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.forgetPassword;
export const resetPasswordUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.resetPassword;

export const LDAPLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.LDAPLogin;

export const OAuthLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.OAuthLogin;

export const OAuthLogoutUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.OAuthLogout;

export const OAuthCallbackUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.OAuthCallback;

export const azureLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.azureLogin;

export const epicLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.epicLogin;

export const feedbackUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.feedback;

export const easyEmailUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.easyEmail;

export const versionUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.versioninfo;

export const EnvConfigUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.envConfig;

export const generateOtpUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.generateOtp;

export const otpVerificationUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.verifyOtp;

export const athenaLoginUrl =
  environment.baseUrl +
  environment.apiEndPoints.auth.base +
  environment.apiEndPoints.auth.athenaLogin;

export const azureLoginService = async (
  data: LoginWithAzureParams
): Promise<any> => {
  return await ServiceRequest.post(azureLoginUrl, {payload: data});
};

export const LDAPloginService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(LDAPLoginUrl, {payload: values});
};

export const OAuthloginService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(OAuthLoginUrl, {payload: values});
};

export const OAuthlogoutService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(OAuthLogoutUrl, {payload: values});
};

export const getAppVersionService = async (
  values : any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(versionUrl, {payload: values});
};

export const OAuthCallbackService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(OAuthCallbackUrl, {payload: values});
};

export const loginService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(loginUrl, {payload: values});
};

export const signUpService = async (
  values: SignupParams
): Promise<SignupResponseMapper> => {
  return await ServiceRequest.post(signUpUrl, {payload: values});
};

export const verifyAccountService = async (
  values: VerifyAccountParams
): Promise<VerifyAccountResponseMapper> => {
  return await ServiceRequest.post(verifyUrl, {payload: values});
};

export const createPasswordService = async (
  values: CreatePasswordParams
): Promise<CreatePasswordResponseMapper> => {
  return await ServiceRequest.post(createPasswordUrl, {payload: values});
};

export const resetPasswordService = async (
  values: ResetPasswordParams
): Promise<ResetPasswordResponseMapper> => {
  return await ServiceRequest.post(resetPasswordUrl, {payload: values});
};

export const forgetPasswordService = async (
  values: ForgetPasswordParams
): Promise<ForgetPasswordResponseMapper> => {
  return await ServiceRequest.post(forgetPasswordUrl, {payload: values});
};

export const epicLoginService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(epicLoginUrl, {payload: values});
};

export const athenaLoginService = async (
  values: any
): Promise<LoginResponseMapper> => {
  return await ServiceRequest.post(athenaLoginUrl, {payload: values});
};

export const feedbackService = async (
  values: any
): Promise<FeedbackResponse> => {
  return await ServiceRequest.post(feedbackUrl, {payload: values});
};

export const easyEmailService = async (
  values: any
): Promise<FeedbackResponse> => {
  return await ServiceRequest.post(easyEmailUrl, {payload: values});
};

export const VersionData = async (): Promise<any> => {
  return ServiceRequest.get(versionUrl);
};

export const ENVConfigData = async (): Promise<any> => {
  return ServiceRequest.get(EnvConfigUrl);
};

export const generateOtpService = async (values: any): Promise<any> => {
  return await ServiceRequest.post(generateOtpUrl, {payload: values});
};

export const verifyOtpService = async (values: any): Promise<any> => {
  return await ServiceRequest.post(otpVerificationUrl, {payload: values});
};

export const adfsLoginService = async (): Promise<any> => {
  return await ServiceRequest.get(adfsLoginUrl, {
    payload: {},
    withCredentials: true,
  });
};

export const adfsCallbackService = async (): Promise<any> => {
  return await ServiceRequest.post(adfsCallbackUrl, {
    payload: {},
    withCredentials: true,
  });
};
